import React, { useEffect, useState } from 'react';
import { Button, Form } from 'antd';
import TextInput from '../inputs/TextInput';
import DateInput from '../inputs/DateInput';
import { getPaymentSearchOptionsService } from '../services/paymenSevices';
import SelectInput from '../inputs/SelectInput';
import useTranslation from '../../hooks/translation/useTranslation';

function PaymentsSearchForm({ onFinish, form }) {
  const { trans } = useTranslation();
  const [statusOptions, setStatusOptions] = useState({
    payment_statuses: [],
    payment_log_statuses: [],
  });

  useEffect(() => {
    const fetchStatuses = async () => {
      const statuses = await getPaymentSearchOptionsService();
      setStatusOptions(statuses);
    };
    fetchStatuses();
  }, []);

  return (
    <Form onFinish={onFinish} layout="vertical" className="grid grid-cols-3 gap-x-4 " form={form}>
      <DateInput label={trans('payment_date')} name="payment_date" />
      <TextInput label={trans('customer_email')} name="email" />
      <TextInput label={trans('refund_approval_code')} name="approval_code" />
      <TextInput label={trans('bank_code')} name="payment_id" />
      <TextInput label={trans('statement_core_id')} name="statement_id" />
      <SelectInput label={trans('status')} options={statusOptions?.payment_statuses} name="status" />
      <SelectInput label={trans('log_status')} options={statusOptions?.payment_log_statuses} name="payment_log_status" />
      <Form.Item label=" " className="w-full">
        <Button className="w=full" type="primary" htmlType="submit">{trans('search')}</Button>
      </Form.Item>
    </Form>
  );
}

export default PaymentsSearchForm;
